module.exports = __webpack_public_path__ + "static/media/adam.f03b7e1a.jpeg";